module.exports = __webpack_public_path__ + "img/43200.52092d72.jpg";